import axios from 'axios'
import store from '@/store'

export async function sendChatbotMessage({ history, message }) {
    const response = await axios.post(
        store.state.settings.chatbot_message_servlet,
        { history: history || [], message },
        {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        }
    )
    return response.data
}
